module.exports = __webpack_public_path__ + "img/check2-null.49a66b91.svg";